(function() {
  const arabicDirham = '\u062f.\u0625.\u200f';
  const currencyMap = {
    AE: 'AED',
    SA: 'SAR',
    KW: 'KWD',
    QA: 'QAR',
    OM: 'OMR',
    BH: 'BHD',
    US: 'USD',
    AU: 'AUD',
    CA: 'CAD',
    EU: 'EUR',
    AM: 'EUR',
    DE: 'EUR',
    FR: 'EUR',
    IT: 'EUR',
    ES: 'EUR',
    NL: 'EUR',
    BE: 'EUR',
    AT: 'EUR',
    PT: 'EUR',
    IE: 'EUR',
    PL: 'EUR',
    RO: 'EUR',
    CZ: 'EUR',
    GR: 'EUR',
    SE: 'EUR',
    HU: 'EUR',
    FI: 'EUR',
    DK: 'EUR',
    SK: 'EUR',
    SI: 'EUR',
    LU: 'EUR',
    EE: 'EUR',
    LV: 'EUR',
    LT: 'EUR',
    MT: 'EUR',
    CY: 'EUR',
    BG: 'EUR',
    HR: 'EUR',
    GB: 'EUR',
    CH: 'EUR',
    NO: 'EUR',
    TR: 'EUR'
  };
  const clientConvertedCurrencies = new Set(['SAR', 'KWD', 'QAR', 'OMR', 'BHD', 'USD', 'AUD', 'CAD', 'EUR']);
  const fallbackExchangeRates = {
    AED: 1,
    SAR: 1.0208,
    KWD: 0.0834,
    QAR: 0.9907,
    OMR: 0.1047,
    BHD: 0.1025,
    EUR: 0.24,
    USD: 0.2723,
    AUD: 0.41,
    CAD: 0.37
  };
  const ratesCacheKey = 'amprio_exchange_rates_aed';
  const ratesCacheTtl = 6 * 60 * 60 * 1000;
  let exchangeRates = fallbackExchangeRates;
  let exchangeRatesRequest;
  let exchangeRatesLoaded = false;

  function getMarketFromPath(pathname, hostname) {
    const host = String(hostname || window.location.hostname || '').toLowerCase();
    const hostPrefix = host.split('.')[0] || '';
    const hostMatch = hostPrefix.match(/^en-([a-z]{2})$/);
    if (hostMatch) return { locale: 'en', country: hostMatch[1].toLowerCase() };
    const arPrefix = pathname.match(/^\/ar-([a-z]{2})(?:$|\/)/);
    if (arPrefix) return { locale: 'ar', country: arPrefix[1].toLowerCase() };
    const enPrefix = pathname.match(/^\/en-([a-z]{2})(?:$|\/)/);
    if (enPrefix) return { locale: 'en', country: enPrefix[1].toLowerCase() };
    if (pathname === '/ar' || pathname.indexOf('/ar/') === 0) return { locale: 'ar', country: (((window.theme || {}).defaultCountry) || 'AE').toLowerCase() };
    return { locale: 'en', country: (((window.theme || {}).defaultCountry) || 'AE').toLowerCase() };
  }

  function pathnameHasExplicitMarketPrefix(pathname) {
    if (!pathname) return false;
    if (pathname === '/ar' || pathname.indexOf('/ar/') === 0) return true;
    return /^\/[a-z]{2}-[a-z]{2}(\/|$)/i.test(pathname);
  }

  function currencyForCountry(countryCode) {
    const code = String(countryCode || '').trim().toUpperCase();
    const storefrontProfile = window.theme?.storefrontProfile || 'main';
    if (storefrontProfile === 'usd' && (code === 'AU' || code === 'CA')) return 'USD';
    return currencyMap[code] || window.theme?.defaultCurrency || 'AED';
  }

  function syncThemeCurrencyFromShopifyCountry() {
    const shopifyCountry = String(window.theme?.shopifyCountry || '').trim().toUpperCase();
    if (shopifyCountry) {
      window.theme = window.theme || {};
      window.theme.country = shopifyCountry;
      window.theme.currency = currencyForCountry(shopifyCountry);
      return;
    }

    const pathname = window.location.pathname || '';
    const storefrontProfile = window.theme?.storefrontProfile || 'main';
    if (!pathnameHasExplicitMarketPrefix(pathname)) {
      window.theme = window.theme || {};
      if (!window.theme.country && window.theme.defaultCountry) {
        window.theme.country = window.theme.defaultCountry;
      }
      if (!window.theme.currency && window.theme.defaultCurrency) {
        window.theme.currency = window.theme.defaultCurrency;
      }
      return;
    }

    const market = getMarketFromPath(pathname, window.location.hostname);
    const countryCode = market.country.toUpperCase();
    const marketCurrency = storefrontProfile === 'usd' && (countryCode === 'AU' || countryCode === 'CA')
      ? 'USD'
      : currencyMap[countryCode] || window.theme?.defaultCurrency || 'AED';

    window.theme = window.theme || {};
    window.theme.country = countryCode;
    window.theme.currency = marketCurrency;
  }

  function formatMinorPrice(minor) {
    const normalizedMinor = Math.round(Number(minor || 0));
    const price = normalizedMinor / 100;
    const fractionDigits = Math.abs(normalizedMinor) % 100 === 0 ? 0 : 2;
    return price.toLocaleString('en-US', {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits
    });
  }

  function readCachedExchangeRates() {
    try {
      const cached = JSON.parse(localStorage.getItem(ratesCacheKey) || 'null');
      if (!cached || !cached.rates || Date.now() - cached.timestamp >= ratesCacheTtl) return null;
      return cached.rates;
    } catch (_) {
      return null;
    }
  }

  function cacheExchangeRates(rates) {
    try {
      localStorage.setItem(ratesCacheKey, JSON.stringify({ timestamp: Date.now(), rates: rates }));
    } catch (_) {
      return undefined;
    }
  }

  function loadExchangeRates() {
    if (exchangeRatesRequest) return exchangeRatesRequest;

    const cachedRates = readCachedExchangeRates();
    if (cachedRates) {
      exchangeRates = { ...fallbackExchangeRates, ...cachedRates, AED: 1 };
      exchangeRatesLoaded = true;
      return Promise.resolve(exchangeRates);
    }

    exchangeRatesRequest = fetch('https://open.er-api.com/v6/latest/AED')
      .then(function(response) {
        if (!response.ok) throw new Error('exchange_rates_unavailable');
        return response.json();
      })
      .then(function(data) {
        if (!data || !data.rates) throw new Error('exchange_rates_invalid');
        exchangeRates = { ...fallbackExchangeRates, ...data.rates, AED: 1 };
        cacheExchangeRates(exchangeRates);
        exchangeRatesLoaded = true;
        return exchangeRates;
      })
      .catch(function() {
        exchangeRatesLoaded = true;
        return exchangeRates;
      });

    return exchangeRatesRequest;
  }

  function convertMinorPrice(minor, sourceCurrency, targetCurrency) {
    if (sourceCurrency === targetCurrency) return minor;

    const sourceRate = Number(exchangeRates[sourceCurrency]);
    const targetRate = Number(exchangeRates[targetCurrency]);
    if (!Number.isFinite(sourceRate) || !Number.isFinite(targetRate) || sourceRate <= 0 || targetRate <= 0) {
      return minor;
    }

    return Math.round((minor / sourceRate) * targetRate);
  }

  function shouldConvertClientSide(activeCurrency) {
    return clientConvertedCurrencies.has(activeCurrency);
  }

  function currencyCodeToSuffix(code) {
    if (code === 'AED' && /^ar(?:-|$)/i.test(document.documentElement.lang || '')) {
      return arabicDirham;
    }
    return code === 'USD' ? '' : code;
  }

  function localizeArabicDirhamText(root) {
    if (!/^ar(?:-|$)/i.test(document.documentElement.lang || '') || !root) return;

    const replaceText = function(node) {
      const currentValue = node.nodeValue || '';
      if (!/\bAED\b/.test(currentValue)) return;
      node.nodeValue = currentValue.replace(/\bAED\b/g, arabicDirham);
    };

    if (root.nodeType === Node.TEXT_NODE) {
      replaceText(root);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) return;
    if (root.nodeType === Node.ELEMENT_NODE && root.matches('script, style, textarea, input, select, option')) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function(node) {
        const parent = node.parentElement;
        if (!parent || parent.closest('script, style, textarea, input, select, option')) {
          return NodeFilter.FILTER_REJECT;
        }
        return /\bAED\b/.test(node.nodeValue || '') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    const matches = [];
    while (walker.nextNode()) matches.push(walker.currentNode);
    matches.forEach(replaceText);
  }

  function removeUnneededZeroDecimals(value) {
    return String(value || '')
      .replace(/([.,])00(?=\s*(?:[A-Z]{3})?\s*$)/, '')
      .replace(/([.,])00$/, '');
  }

  function formatTabbyInstallment(price) {
    const num = Number(price);
    if (!Number.isFinite(num)) return '';
    const monthly = num / 4;
    return monthly % 1 === 0 ? String(Math.round(monthly)) : monthly.toFixed(2);
  }

  function normalizeRenderedPriceValues() {
    document.querySelectorAll('[data-price-value], [data-compare-value], [data-tabby-price]').forEach(function(el) {
      const currentValue = el.textContent || '';
      const nextValue = removeUnneededZeroDecimals(currentValue);
      if (nextValue !== currentValue) el.textContent = nextValue;
    });
  }

  function renderPriceContainer(container, activeCurrency) {
    if (!container) return;

    const minorRaw = container.getAttribute('data-price-minor');
    const priceMinor = parseInt(minorRaw == null ? '' : minorRaw, 10);
    if (Number.isNaN(priceMinor)) return;

    const sourceCurrency = String(
      container.dataset.sourceCurrency || window.theme?.baseCurrency || window.theme?.defaultCurrency || 'AED'
    ).toUpperCase();
    const displayPriceMinor = shouldConvertClientSide(activeCurrency)
      ? convertMinorPrice(priceMinor, sourceCurrency, activeCurrency)
      : priceMinor;
    const priceValueEl = container.querySelector('[data-price-value]');
    if (priceValueEl) {
      const formattedPrice = formatMinorPrice(displayPriceMinor);
      priceValueEl.textContent = activeCurrency === 'USD' ? '$' + formattedPrice : formattedPrice;
    }

    const compareRaw = container.getAttribute('data-compare-minor');
    if (compareRaw != null && compareRaw !== '') {
      const compareMinor = parseInt(compareRaw, 10);
      if (!Number.isNaN(compareMinor)) {
        const compareValueEl = container.querySelector('[data-compare-value]');
        if (compareValueEl) {
          const displayCompareMinor = shouldConvertClientSide(activeCurrency)
            ? convertMinorPrice(compareMinor, sourceCurrency, activeCurrency)
            : compareMinor;
          const formattedCompare = formatMinorPrice(displayCompareMinor);
          compareValueEl.textContent = activeCurrency === 'USD' ? '$' + formattedCompare : formattedCompare;
        }
      }
    }
  }

  function refreshPriceDisplay() {
    syncThemeCurrencyFromShopifyCountry();

    const activeCurrency = window.theme?.currency || window.theme?.defaultCurrency || 'AED';
    const currencySuffix = currencyCodeToSuffix(activeCurrency);

    [
      '[data-price-currency]',
      '[data-compare-currency]',
      '.tabby-text [data-tabby-currency]',
      '.item-selection-product-price [data-price-currency]',
      '.item-selection-product-price [data-compare-currency]'
    ].forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(el) {
        if (el.textContent !== currencySuffix) {
          el.textContent = currencySuffix;
        }
      });
    });

    document.querySelectorAll('[data-price-minor]').forEach(function(container) {
      renderPriceContainer(container, activeCurrency);
    });

    normalizeRenderedPriceValues();
    localizeArabicDirhamText(document.body);

    if (activeCurrency === 'USD') {
      document.querySelectorAll('[data-tabby-price]').forEach(function(el) {
        const raw = removeUnneededZeroDecimals((el.textContent || '').replace(/^\$\s*/, '').trim());
        if (raw) el.textContent = '$' + raw;
      });
    } else {
      document.querySelectorAll('[data-tabby-price]').forEach(function(el) {
        const raw = el.textContent || '';
        const nextValue = removeUnneededZeroDecimals(raw);
        if (nextValue !== raw) el.textContent = nextValue;
      });
    }

    if (!exchangeRatesLoaded && shouldConvertClientSide(activeCurrency)) {
      loadExchangeRates().then(refreshPriceDisplay);
    }

  }

  window.formatMinorPrice = formatMinorPrice;
  window.formatCurrencySuffix = currencyCodeToSuffix;
  window.formatTabbyInstallment = formatTabbyInstallment;

  document.addEventListener('theme:convert-prices', refreshPriceDisplay);
  document.addEventListener('variant:update', function() {
    requestAnimationFrame(refreshPriceDisplay);
  });
  document.addEventListener('shopify:section:load', function() {
    requestAnimationFrame(refreshPriceDisplay);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      refreshPriceDisplay();
      observeRenderedCurrency();
    });
  } else {
    refreshPriceDisplay();
    observeRenderedCurrency();
  }

  function observeRenderedCurrency() {
    if (!/^ar(?:-|$)/i.test(document.documentElement.lang || '') || !document.body) return;
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(localizeArabicDirhamText);
        if (mutation.type === 'characterData') localizeArabicDirhamText(mutation.target);
      });
    });
    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  }
})();
